export const RECHARGE_WALLET_SUCCESS = 'RECHARGE_WALLET_SUCCESS';
export const RECHARGE_WALLET_REQUEST = 'RECHARGE_WALLET_REQUEST';
export const RECHARGE_WALLET_FAILURE = 'RECHARGE_WALLET_FAILURE';
export const RECHARGE_WALLET_RESET = 'RECHARGE_WALLET_RESET';
export const rechargeWalletSuccess = (payload) => ({
    type: RECHARGE_WALLET_SUCCESS,
    payload,
});
export const rechargeWalletRequest = (payload) => ({
    type: RECHARGE_WALLET_REQUEST,
    payload,
});
export const rechargeWalletFailure = (payload) => ({
    type: RECHARGE_WALLET_FAILURE,
    payload
});
export const rechargeWalletReset = () => ({
    type: RECHARGE_WALLET_RESET,
});
